import { css } from "@compiled/react";

import { wacToken } from "@/libraries/design/foundations/index.ts";
import { Icon } from "@/libraries/wpl/foundations/src/icon";

export const Checkmark = () => {
    return (
        <span css={containerInnerCss} data-testid="checkmark">
            <Icon
                name="featurecheckmark"
                size="xs"
                color={wacToken("color.neutral.light0")}
            />
        </span>
    );
};

const containerInnerCss = css({
    backgroundColor: wacToken("color.extended.lime700"),
    borderRadius: "50%",
    color: wacToken("color.neutral.light0"),
    display: "inline-block",
    flexShrink: 0,
    fontWeight: "bold",
    lineHeight: "24px",
    textAlign: "center",
    height: "24px",
    width: "24px"
});
